//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/SketchGeometryBuilder.js";
import "../no/Expression.js";
import "../no/ugmath.js";
import "../no/Expression.js";
let d=[[[1,"Diameter",0,"Expression",0],[0,"LockDiameter",1,0]],[[["firstPoint"],"SetFirstPoint",{},1,0],[["secondPoint"],"SetSecondPoint",{},1,0],[["thirdPoint"],"SetThirdPoint",{},1,0],[["firstPoint"],"SnapFirstPoint",{},1,0],[["secondPoint"],"SnapSecondPoint",{},1,0],[["thirdPoint"],"SnapThirdPoint",{},1,0],[[],"GetFirstPoint",{R_:{firstPoint:"Point"}},0,0],[[],"GetSecondPoint",{R_:{secondPoint:"Point"}},0,0],[[],"GetThirdPoint",{R_:{thirdPoint:"Point"}},0,0],[[],"RemoveThirdPoint",{},0,0],[["solveType","pointIndex","inputPoint","diameter"],"GetPreviousSuccessfulSolve",{},0,0]],[]];
SPLM.SketchCircleThreePointsBuilder = class extends SPLM.SketchGeometryBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.SketchCircleThreePointsBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.SketchCircleThreePointsBuilder.SolveType = Object.freeze({
    "None" : "None", "Diameter" : "Diameter", "DefiningPoint" : "DefiningPoint"});

export default SPLM;